import { EJavaClassNames } from '@adaptiva/data-service';
import { ServerObjectViewModule } from '@adaptiva/widgets/server-object-view';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [ServerObjectViewModule.with(EJavaClassNames.Schedule)]
})
export class ScheduleModule {

}
